import { Component } from '@angular/core';

@Component({
  selector: 'sw-section-three',
  templateUrl: './section-three.component.html',
})
export class SectionThreeComponent {

}
